import { UseFormRegister, UseFormRegisterReturn } from "react-hook-form";
import React from "react";
import { IConditional } from "../../../../hooks/useConditionals";
import { IFormInput } from "./IFormInput";

export const Input = ({ name, register, type, ...props }: IFormInput<any>) => {
    // @ts-ignore
    return <input type={type} className={"border-gray-500 border rounded px-4 py-2"} {...register(name)} {...props} />;
};
